/* eslint-disable */

const ua = window.navigator.userAgent.toLowerCase();

// ios
export const isIOS = () => {
    return /iphone|ipad|ipod/.test(ua);
};

// Android
export const isAndroid = () => {
    return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
};

// 鸿蒙
export const isHarmonyOS = () => {
    // 鸿蒙手机也可以安装安卓版手百，先判断非安卓
    return (!isAndroid() && /OpenHarmony|HarmonyOS/i.test(ua));
};

// 手百客户端
export const isShoubai = () => {
    return /baiduboxapp/.test(ua);
};

// 微信
export const isWeiXin = () => {
    return /micromessenger/.test(ua);
};

// QQ客户端
export const isQQ = () => {
    if (isAndroid()) {
        return ua.indexOf(' qq') > -1 && ua.indexOf('mqqbrowser') > -1;
    }
    return /\sQQ/i.test(ua);
};

// QQ浏览器
export const isQQBrowser = () => {
    return ua.indexOf('mqqbrowser') > -1 && ua.indexOf(' qq') < 0;
};

// 微博
export const isWeibo = () => {
    return /weibo/.test(ua);
};

// 如流app
export const isBiaduHi = () => {
    return /baiduhi/.test(ua);
};

export const isBaiJiaHao = () => {
    return /baijiahao/i.test(ua);
};

export const isDucut = () => {
    return /ducut/i.test(ua);
};

// 大部分vivo机型在 (Linux; Android xx; XXXXX Build/xxx) 括号内携带型号，格式多为 V数字A，示例：V2148A
// 少数旧版本 UA 会直接写 vivo
export const isVivo = () => {
    return /(V\d+A|vivo)/i.test(ua);
};

export const getEnv = () => {
    // eslint-disable-next-line
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        return 'h5';
    }
    return 'pc';
};
